export default __webpack_public_path__ + "static/media/flayer2.ea445cc7.jpg";